import React, {useEffect, useRef, useState} from 'react';
import {Button, Card, Container, Image, Modal, ProgressBar,Spinner} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './luckyDetail.css';
import axios from "axios";
import html2canvas from 'html2canvas';
import {useNavigate} from "react-router-dom";

const getCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');

    return `${year}년${month}월${day}일 ${hours}시${minutes}분`;
}

function lottoNumbers() {
    const numbers = new Set();
    while (numbers.size < 6) {
        const randomNum = Math.floor(Math.random() * 45) + 1;
        numbers.add(randomNum);
    }
    return Array.from(numbers).sort((a, b) => a - b).join(', ');
}

const generateRandomPercentage = () => Math.floor(Math.random() * 101);

const LuckyDetail = () => {
    const navigate = useNavigate()
    const [score1, setScore1] = useState(0);
    const [score2, setScore2] = useState(0);
    const [result, setResult] = useState({
        id: '',
        lucky: '',
        luckyDetail: ''
    });
    const [progress, setProgress] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [modalText,setModalText] = useState('이미지 저장중 입니다...')
    const imageBody = useRef(null);
    const [lottoNumbersState, setLottoNumbersState] = useState('');
    const [isDownloading, setIsDownloading] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [imageUrl, setImageUrl] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [backColor, setBackColor] = useState('');

    useEffect(() => {
        setBackColor(randomBrightColor());
        fetchUserIP();
        fetchLuckyImage();
        fetchLuckyData();
        setScore1(generateRandomPercentage());
        setScore2(generateRandomPercentage());
        setLottoNumbersState(lottoNumbers());
        setIsLoaded(true);
    }, []);

    const fetchLuckyImage = async () => {
        setIsLoading(true);
        setHasError(false);
        try {
            const luckyKeywords = [
                'four-leaf-clover',
                'rainbow',
                'shooting-star',
                'lucky-cat',
                'horseshoe',
                'golden-coins',
                'ladybug'
            ];
            const randomKeyword = luckyKeywords[Math.floor(Math.random() * luckyKeywords.length)];

            const response = await fetch(
                `https://api.unsplash.com/photos/random?query=${randomKeyword}&orientation=landscape&client_id=${process.env.REACT_APP_UNSPLASH_ACCESS_KEY}`
            );
            const data = await response.json();

            // 이미지 URL을 가져와서 blob으로 변환
            const imageResponse = await fetch(data.urls.regular);
            const blob = await imageResponse.blob();

            // Blob을 Base64로 변환
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
                const base64data = reader.result;
                setImageUrl(base64data);
            };
        } catch (error) {
            console.error('이미지 가져오기 오류:', error);
            setHasError(true);
        }
    };

    const getDeviceInfo = async (userAgent) => {
        const isMobile = /Mobi|Android/i.test(userAgent);
        const isTablet = /Tablet|iPad/i.test(userAgent);

        return {
            device: isMobile ? 'Mobile' : isTablet ? 'Tablet' : 'Desktop',
            userAgent
        };
    };

    const fetchLuckyData = async () => {
        try {
            const res = await axios.get('/api/getLucky');
            setResult(res.data);
        } catch (e) {
            alert('운세 조회에 실패하였습니다: ' + e);
        }
    };

    const fetchUserIP = async () => {
        const userAgent = navigator.userAgent;
        const deviceInfo  =  await getDeviceInfo(userAgent);

        try {
            const response = await fetch(`https://ipinfo.io/json?token=${process.env.REACT_APP_IPINFO_API_KEY}`);
            const data = await response.json();
            axios.post('/api/setHistory',{ ip: String(data.ip) ,device :deviceInfo.device ,userAgent:deviceInfo.userAgent})
                .then(res => {
                    if (res.data) {
                        setResult(res.data);
                    }
                })
        } catch (e) {
            alert('운세 조회에 실패하였습니다 ' + e);
        }
    }


    const saveImage = async () => {
        if (isDownloading) return;
        setIsDownloading(true);
        setIsLoaded(false);
        setProgress(0);
        setShowModal(true);

        await new Promise(resolve => setTimeout(resolve, 1000)); // 이미지 완전 로드 대기

        const options = {
            useCORS: true,
            allowTaint: true,
            imageTimeout: 0,
            scale: 2,
            logging: true,
            backgroundColor: null
        };

        try {
            const element = imageBody.current;
            const canvas = await html2canvas(element, options);
            setModalText('이미지 저장중 입니다...');

            const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));

            if (blob) {
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `${getCurrentDate()}_운세.png`;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // Object URL 해제 지연 처리
                setTimeout(() => {
                    URL.revokeObjectURL(url);
                }, 5000); // 5초 후 해제

                setProgress(100);
                setTimeout(() => {
                    setShowModal(false);
                    setIsDownloading(false);
                }, 1500);
            } else {
                throw new Error('Blob 생성 실패');
            }
        } catch (error) {
            console.error('이미지 저장 오류:', error);
            alert('이미지 저장에 실패했습니다: ' + error.message);
            setShowModal(false);
            setIsDownloading(false);
        }
    };

    const handleShare = () => {
        const endingMessages = [
            "👉 '당신의 운명은 당신의 선택입니다.' 지금 숨겨진 가능성을 찾아보세요!",
            "🎯 '모든 것은 당신의 마음에서 시작됩니다.' 특별한 메시지를 받아들여 기적을 만나는 하루로!",
            "✨ '연결된 운세는 더 빛납니다.' 함께 새로운 여정을 떠나봅시다.",
            "🍀 '행운은 준비된 자에게 미소를 짓습니다.' 필요한 행운을 함께 창조해요!",
            "🎲 '기회는 행동하는 자에게 찾아옵니다.' 당신의 진정한 모습을 발견하세요.",
            "🌟 '오늘은 기적의 시작입니다.' 당신의 마음속에 특별함을 느껴보세요.",
            "💫 '운명은 당신이 만들어갑니다.' 함께 새로운 길을 열어가요!",
            "🎪 '희망의 문은 용기 있는 자에게 열립니다.' 당신의 용기를 믿으세요!",
            "🎯 '별들이 전하는 메시지는 중요합니다.' 혁신할 열쇠를 찾아보세요.",
            "🎨 '당신의 이야기가 세상을 변화시킵니다.' 아름다운 이야기를 그려보세요.",
        ];

        // 랜덤하게 하나 선택
        const randomMessage = endingMessages[Math.floor(Math.random() * endingMessages.length)];

        const smsText = `${getCurrentDate()} 운세\n`
            + `오늘의 총운: ${score1}%\n`
            + `로또 당첨 확률: ${score2}%\n`
            + `행운의 번호: [${lottoNumbers()}]\n`
            + `오늘의 Tip: ${result.lucky}\n\n`
            + `${randomMessage}`;

        const smsUrl = `sms:?&body=${encodeURIComponent(smsText)}`;
        window.location.href = smsUrl;
    };

    const randomBrightColor = () => {
        const r = Math.floor(Math.random() * 156) + 100; // 100~255
        const g = Math.floor(Math.random() * 156) + 100; // 100~255
        const b = Math.floor(Math.random() * 156) + 100; // 100~255
        return `rgb(${r}, ${g}, ${b})`;
    };


    return (
        <Container className={`fortune-detail-container d-flex flex-column align-items-center justify-content-center ${isLoaded ? 'zoom-in-animation' : ''}`} style={{backgroundColor:backColor}} ref={imageBody}>
            <Card className="text-center p-3">
                <Card.Title className="level-title bold">🔔미래를 확인한 시간🔔</Card.Title>
                <Card.Title className="level-title">{getCurrentDate()}</Card.Title>
                {isLoading && !hasError && (
                    <div className="text-center">
                        <Spinner animation="border" />  {/* 로딩 스피너 표시 */}
                    </div>
                )}

                {imageUrl && (
                    <Image
                        src={imageUrl}
                        alt="행운이미지"
                        className="character-image my-3"
                        rounded
                        onLoad={() => setIsLoading(false)}
                        onError={() => {
                            setHasError(true);
                            setIsLoading(false);
                        }}
                    />
                )}

                {hasError && (
                    <Image
                        src={`${process.env.PUBLIC_URL}/img/lucky.jpg`}
                        alt="네잎클로버"
                        className="character-image my-3"
                        rounded
                    />
                )}
                <div className="score-section" style={{ marginBottom: '10px' }}>
                    <span>오늘의 총운 ({score1}%)</span>
                    <div className="score" style={{ marginBottom: '10px' }}>
                        <ProgressBar now={score1} variant="danger" className="score-bar" />
                        <span className="score-icon">{score1 < 50 ? '☘️' :'🍀'}</span>
                    </div>
                    <span>로또 당첨 확률 ({score2}%)</span>
                    <div className="score">
                        <ProgressBar now={score2} variant="primary" className="score-bar" />
                        <span className="score-icon">{score2 < 50 ? '☘️' :'🍀'}</span>
                    </div>
                </div>
                <div className="description mt-3">
                    {result.lucky}<br />
                    {result.luckyDetail}
                </div>
                <Card className="likes-card p-2 mb-3">
                    <span>행운의 번호</span>
                    <div className="likes-item mt-2">[{lottoNumbersState}]</div>
                </Card>

                <Button variant="danger" className="custom-button mb-2" onClick={saveImage}>운세 이미지 저장하기</Button>
                <Button variant="primary" className="custom-button mb-2" onClick={handleShare}>📨 SMS 공유하기 ➔</Button>
                <Button variant="secondary" size="sm" onClick={()=>{navigate('/contact')}}>문의하기</Button>
            </Card>

            {/* 모달 추가 */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{modalText}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ProgressBar now={progress} label={`${progress}%`} />
                </Modal.Body>
            </Modal>
        </Container>
    );
}

export default LuckyDetail;
